import { render, staticRenderFns } from "./homeBtn.vue?vue&type=template&id=4f3b9cf8&scoped=true"
import script from "./homeBtn.vue?vue&type=script&lang=js"
export * from "./homeBtn.vue?vue&type=script&lang=js"
import style0 from "./homeBtn.vue?vue&type=style&index=0&id=4f3b9cf8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3b9cf8",
  null
  
)

export default component.exports